import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useAuth } from "../AuthContext";
import api from "../api";
import { ShareNetwork, Copy, PaperPlaneTilt, EnvelopeSimple } from "@phosphor-icons/react";

export const ShareCard = () => {
  const { user } = useAuth();
  const [show, setShow] = useState(false);
  const [url, setUrl] = useState(null);
  useEffect(() => {
    api.get("/card-link").then((r) => setUrl(r.data.enabled === false ? null : r.data.url)).catch(() => {});
  }, []);
  if (!user || !url) return null;
  const text = encodeURIComponent(`Here's our business card — call, text, or leave us a review: ${url}`);

  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast.success("Card link copied"); }
    catch { toast.error("Couldn't copy — long-press the link instead"); }
  };

  return (
    <div className="card-flat mb-4 p-4" data-testid="share-card">
      <button data-testid="share-card-toggle" onClick={() => setShow(!show)}
        className="flex w-full items-center justify-center gap-2 text-sm font-bold">
        <ShareNetwork size={18} weight="bold" /> Share your business card
      </button>
      {show && (
        <div className="mt-3 space-y-2">
          <p className="break-all rounded-md bg-muted p-2 text-center text-xs" data-testid="share-card-url">{url}</p>
          <div className="grid grid-cols-3 gap-2">
            <button data-testid="share-card-copy" onClick={copy} className="flex h-12 items-center justify-center gap-1 rounded-md border border-border text-xs font-bold"><Copy size={16} /> Copy</button>
            <a data-testid="share-card-text" href={`sms:?&body=${text}`} className="flex h-12 items-center justify-center gap-1 rounded-md border border-border text-xs font-bold"><PaperPlaneTilt size={16} /> Text</a>
            <a data-testid="share-card-email" href={`mailto:?subject=${encodeURIComponent("Our business card")}&body=${text}`} className="flex h-12 items-center justify-center gap-1 rounded-md border border-border text-xs font-bold"><EnvelopeSimple size={16} /> Email</a>
          </div>
        </div>
      )}
    </div>
  );
};
